module.exports = __webpack_public_path__ + "static/media/blue-yellow.f9bd7a0b.png";